export function publishToAgent(room, type, payload = {}) {
  if (!room?.localParticipant) return;
  const msg = JSON.stringify({ type, ...payload });
  room.localParticipant.publishData(new TextEncoder().encode(msg), { reliable: true });
}
